import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData, NavigationNode, NavigationService } from '@spartacus/storefront';
import { Observable, of, shareReplay, switchMap } from 'rxjs';

@Component({
  selector: 'app-shared-navigation',
  templateUrl: './shared-navigation.component.html',
  styleUrl: './shared-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SharedNavigationComponent {

  componentData$: Observable<CmsNavigationComponent>;
  data$: Observable<NavigationNode>;

  constructor(
    private component: CmsComponentData<CmsNavigationComponent>,
    private navigationService: NavigationService,
  ) { }

  ngOnInit(): void {
    const sharedComponentData$ = this.component.data$
      .pipe(
        shareReplay(1)        // ensures this observable is subscribed to only once
      );                      // and emits the last value to new subscribers.

    this.componentData$ = sharedComponentData$;

    this.data$ = sharedComponentData$
      .pipe(
        switchMap(data => this.navigationService.getNavigationNode(of(data)))
      );
  }
}
